import { generateRandomArray } from '../utils';
import { MOD_DATA, MOD_CHECK, MOD_PIN, MOD_PST_ST, MOD_DETAILS, MOD_FLT_BD_DATE, MOD_FLT_LIMIT, MOD_TAB, MOD_SRC_TAG, MOD_PAGIN, MOD_EP_LOD, MOD_FLT_TAG, MOD_FLT_FEED, MOD_FLT_TYPE, MOD_FLT_TAG_RM, MOD_FLT_FEED_RM, MOD_FLT_TYPE_RM, MOD_ALL_FLT_RM, MOD_SEC_PST, MOD_FLT_DATE, MOD_FLT_DATE_RM, MOD_FLT_TAG_EXTD, MOD_CHECK_DT, MOD_CHECK_DT_RM, MOD_CHECK_DT_ALL, MOD_CHECK_DT_B, MOD_CHECK_DT_BRM, MOD_OFFSET, UGC_DATA, UGC_TMP_ADD, OPEN_UGC, UGC_TMP_RM, UGC_TMP_UP, UGC_REQ_DATA, UGC_DATA_RM, MOD_PIN_LIST, MOD_PST_REF, MOD_PST_FILE_UPDATE, MOD_LOD, MOD_RECOMM, MOD_RECOMM_RM, MOD_SENTI, MOD_SENTI_RM, MOD_LANG, MOD_LANG_RM, ADD_FEED_NETWORKS, MOD_NOTI, MOD_FLT_RULE, MOD_FLT_RULE_RM, } from './keys'

const initialState = {
    filter: {wallId: null, feeds: [], postType: [], text: "", highlight: "", pinned: 0, status: 0, offset_start: 0, postList: [], rulename: "",feedFilter: "", startDate: "", endDate: "", limit: 50, tags: [], searchByTag: 0, recommendation: [], sentiment: [], language: [] },
    details: { privatepost: 0, publicpost: 0, totalpost: 0 },
    listData: [],
    total: 0,
    isCheckedPostCount: 0,
    paginateData: { currentPage: 1, totalPages: 1, pages: [] },
    isEditing: false,
    filterBody: { postTags: [], socialFeed: [], postType: [], other: [], ugc: [], recommendation: [],sentiment: [],language: [], rules: [], dateRanges: {} },
    check_uncheck_all: { status: false, data: [] },
    searchData: [],
    addFeedNetworks: null,
    ugcData: {},
    ugcPopup: false,
    ugcRequestData: [],
    loding: true,
    filterLoader: true,
    pinToTop: null,
    changeModeration_wall: false
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case MOD_OFFSET: {
            return { ...state, filter: { ...state.filter, offset_start: action.payload } };
        }

        case MOD_CHECK_DT_B: {
            const { status, data } = action.payload;
            return {
                ...state,
                check_uncheck_all: {
                    ...state.check_uncheck_all, status,
                    data: [...state.check_uncheck_all.data, ...(data || []).filter(item => !state.check_uncheck_all.data.some(x => x.id === item.id))
                    ]
                }
            };
        }

        case MOD_CHECK_DT_BRM: {
            const { status, data } = action.payload;
            return {
                ...state,
                check_uncheck_all: {
                    ...state.check_uncheck_all, status,
                    data: state.check_uncheck_all.data.filter((item) => !(data || []).some((x) => x.id === item.id)),
                },
            };
        }

        case MOD_CHECK_DT: {
            const { status, data } = action.payload;
            if (!state.check_uncheck_all.data.some(x => x.id === data.id)) state.check_uncheck_all.data.push(data);
            state.check_uncheck_all.status = status;
            return { ...state };
        }

        case MOD_CHECK_DT_RM: {
            const { status, data } = action.payload;
            return { ...state, check_uncheck_all: { ...state.check_uncheck_all, status, data: state.check_uncheck_all.data.filter((item) => item.id !== data.id), }, };
        }

        case MOD_CHECK_DT_ALL: { return { ...state, check_uncheck_all: { ...state.check_uncheck_all, status: false, data: [] } } }


        case MOD_PAGIN: {
            const { currentPage = 1, offset = 0 } = action.payload;
            return { ...state, filter: { ...state.filter, offset_start: offset, }, paginateData: { ...state.paginateData, currentPage, }, };
        }

        case MOD_SRC_TAG: {
            const { filter, filterBody } = state;
            const tagToAddOrRemove = `+${action.payload}`;
            filter.searchByTag = 1;
            if (!filter.tags.includes(tagToAddOrRemove)) { filter.tags = [...filter.tags, tagToAddOrRemove]; }
            else {
                filter.tags = filter.tags.filter((tag) => tag !== tagToAddOrRemove);
                filterBody.postTags = filterBody.postTags.filter((tag) => tag !== action.payload);
            }
            return { ...state, filter: { ...filter }, filterBody: { ...filterBody }, };
        }

        case MOD_SEC_PST: {
            return { ...state, filter: { ...state.filter, text: action.payload, searchByTag: 0, }, };
        }

        case MOD_TAB: {
            return { ...state, filter: { ...state.filter, status: action.payload, }, };
        }

        case MOD_FLT_BD_DATE: {
            return { ...state, filter: { ...state.filter, startDate: action.payload.startDate, endDate: action.payload.endDate, }, };
        }

        case MOD_FLT_LIMIT: {
            return { ...state, filter: { ...state.filter, limit: action.payload, offset_start: 0, }, paginateData: { ...state.paginateData, currentPage: 1, }, };
        }

        case MOD_DATA: {
            const { listData, total, page } = action.payload;
            return { ...state, listData, total, paginateData: { ...state.paginateData, pages: generateRandomArray(page), totalPages: page, }, loding: false, };
        }

        case MOD_CHECK: {
            return { ...state, ...action.payload, };
        }

        case MOD_FLT_TAG_EXTD: {
            const { filterBody } = state;
            if (!filterBody.postTags.includes(action.payload)) filterBody.postTags.push(action.payload)
            return { ...state, filterBody }
        }

        case MOD_FLT_TAG: {
            return { ...state, filter: { ...state.filter, tags: [...state.filter.tags, `+${action.payload}`], }, filterBody: { ...state.filterBody, postTags: [...state.filterBody.postTags, action.payload], }, };
        }

        case MOD_FLT_FEED: {
            return { ...state, filter: { ...state.filter, feedFilter: "1", feeds: [...state.filter.feeds, action.payload.value], }, filterBody: { ...state.filterBody, socialFeed: [...state.filterBody.socialFeed, action.payload], }, };
        }

        case MOD_FLT_TYPE: {
            return { ...state, filter: { ...state.filter, postType: [...state.filter.postType, action.payload], }, filterBody: { ...state.filterBody, postType: [...state.filterBody.postType, action.payload], }, };
        }

        case MOD_FLT_TAG_RM: {
            const { findIndex, value, isText } = action.payload;
            return {
                ...state,
                filterBody: { ...state.filterBody, postTags: state.filterBody.postTags.filter((_, index) => index !== findIndex), },
                filter: { ...state.filter, tags: state.filter.tags.filter((tag) => tag !== `+${value}`), text: isText ? "" : state.filter.text },
            };
        }

        case MOD_FLT_FEED_RM: {
            const { findIndex, value } = action.payload;
            return {
                ...state,
                filterBody: { ...state.filterBody, socialFeed: state.filterBody.socialFeed.filter((_, index) => index !== findIndex), },
                filter: { ...state.filter, feeds: state.filter.feeds.filter((item) => item !== value), feedFilter: state.filter.feeds.length === 1 && state.filter.feeds[0] === value ? "" : state.filter.feedFilter, },
            };
        }

        case MOD_FLT_TYPE_RM: { return removeFilterValue('postType', 'postType', state, action); }

        case MOD_RECOMM: {
            return { ...state, filter: { ...state.filter, recommendation: [...state.filter.recommendation, action.payload], }, filterBody: { ...state.filterBody, recommendation: [...state.filterBody.recommendation, action.payload], }, };
        }


        case MOD_RECOMM_RM: {
            const { findIndex, value } = action.payload;
            return {
                ...state,
                filterBody: { ...state.filterBody, recommendation: state.filterBody.recommendation.filter((_, index) => index !== findIndex), },
                filter: { ...state.filter, recommendation: state.filter.recommendation.filter((item) => item !== value), },
            };
        }

        case MOD_SENTI: {
            return {
                ...state,
                filter: { ...state.filter, sentiment: [...state.filter.sentiment, action.payload], },
                filterBody: { ...state.filterBody, sentiment: [...state.filterBody.sentiment, action.payload], },
            };
        }

        case MOD_SENTI_RM: {
            const { findIndex, value } = action.payload;
            return {
                ...state,
                filterBody: { ...state.filterBody, sentiment: state.filterBody.sentiment.filter((_, index) => index !== findIndex), },
                filter: { ...state.filter, sentiment: state.filter.sentiment.filter((item) => item !== value), },
            };
        }

        case MOD_LANG: {
            const languageArray = Array.isArray(state.filterBody.language) ? state.filterBody.language : [];
            return {
                ...state,
                filter: { ...state.filter, language: [...state.filter.language, action.payload] },
                filterBody: { ...state.filterBody, language: [...languageArray, action.payload] },
            };
        }


        case MOD_LANG_RM: {
            const { findIndex, value } = action.payload;
            return {
                ...state,
                filterBody: { ...state.filterBody, language: state.filterBody.language.filter((_, index) => index !== findIndex), },
                filter: { ...state.filter, language: state.filter.language.filter((item) => item !== value), },
            };
        }

        case MOD_ALL_FLT_RM: {
            return {
                ...state,
                filter: { ...state.filter, tags: [], postType: [], feeds: [], highlight: "", pinned: 0, startDate: "", offset_start:0, postList: [], rulename: "", endDate: "", feedFilter: "", recommendation: [], sentiment: [], text: "", limit: 50, searchByTag: 0, recommendation: [], sentiment: [], language: []},
                filterBody: { postTags: [], socialFeed: [], postType: [], other: [], dateRanges: {}, recommendation: [], sentiment: [], language: [], rules: []},
            };
        }
        case MOD_FLT_RULE: {
            const rulesArray = Array.isArray(state.filterBody.rules) ? state.filterBody.rules : [];
            console.log('rulesArray', rulesArray, action.payload)
            return { ...state, filterBody: { ...state.filterBody, rules: [...rulesArray, action.payload] } };
        }
        case MOD_FLT_DATE: { return { ...state, filterBody: { ...state.filterBody, dateRanges: action.payload, }, }; }
        case MOD_FLT_DATE_RM: { return { ...state, filter: { ...state.filter, startDate: "", endDate: "", }, filterBody: { ...state.filterBody, dateRanges: {}, }, }; }
        case ADD_FEED_NETWORKS: { return { ...state, addFeedNetworks: action.payload } }
        case UGC_DATA: { return { ...state, ugcData: action.payload } }
        case OPEN_UGC: { return { ...state, ugcPopup: action.payload } }
        case UGC_TMP_ADD: { return { ...state, ugcData: { ...state.ugcData, template: [...state.ugcData.template, action.payload], }, }; }
        case UGC_TMP_RM: { return { ...state, ugcData: { ...state.ugcData, template: state.ugcData.template.filter((t) => t.id !== action.payload), }, }; }
        case UGC_TMP_UP: { return { ...state, ugcData: { ...state.ugcData, template: [...state.ugcData.template.filter((t) => t.id !== action.payload.id), action.payload,], }, }; }
        case MOD_LOD: { return { ...state, filterLoader: action.payload } }
        case MOD_DETAILS: { return { ...state, details: action.payload } }
        case MOD_PIN: { return { ...state, listData: action.payload } }
        case MOD_PST_ST: { return { ...state, listData: action.payload } }
        case MOD_EP_LOD: { return { ...state, isEditing: action.payload } }
        case UGC_REQ_DATA: { return { ...state, ugcRequestData: action.payload } }
        case UGC_DATA_RM: { return { ...state, ugcRequestData: [] } }
        case MOD_PIN_LIST: { return { ...state, pinToTop: action.payload } }
        case MOD_PST_REF: return { ...state, listData: updatePostArray(action.payload, action.postType, state.listData) }
        case MOD_PST_FILE_UPDATE: {
            const { id, postFile } = action.payload;
            return { ...state, listData: state.listData.map(item => item.id == id ? { ...item, postFile } : item) }
        }
        case MOD_FLT_RULE_RM: { return { ...state, filterBody: { ...state.filterBody, rules: [] }, filter: { ...state.filter, postList:[]}, }; }
        case MOD_NOTI: {
            const { posts, rulename } = action.payload;
            return { ...state, filter: { ...state.filter, postList: posts || [], rulename: rulename|| (posts?.length > 0 ? "Notification" : "") } }; 
        }

        default:
            return { ...state }
    }

}

const updatePostArray = (data, postType, listData) => {
    const updatedListData = listData.map(item => {
        const updatedItem = data.find(d => item.id === d.id);
        if (updatedItem) return { ...item, ...updatedItem, newMedia: updatedItem.postFile, mediaUrl: updatedItem.mediaFile, type: updatedItem.mediaFile ? '3' : '2' };
        else return item;
    });
    return updatedListData;
}


const removeFilterValue = (filterBodyKey, filterKey, state, action) => {
    const { findIndex, value } = action.payload;

    return {
        ...state,
        filterBody: { ...state.filterBody, [filterBodyKey]: state.filterBody[filterBodyKey].filter((_, index) => index !== findIndex), },
        filter: { ...state.filter, [filterKey]: state.filter[filterKey].filter((item) => item !== value), },
    };
};